export default __webpack_public_path__ + "static/tag-dont-4-light-96d7d3b654c6cc1dd13d7eca21ac43db505e6ffa4da55281116cca93da73a22c.png";